import { Bell, Boat, CirclesFour, PersonSimpleThrow, SlidersHorizontal } from '@phosphor-icons/react';
import { Collapser, semanticColors, VText } from '@vake/ui-kit';
import { FC, ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';

const SidebarHeadline: FC<{ text: string; iconBefore?: ReactNode }> = ({ text, iconBefore }) => {
    const [open, setOpen] = useState(false);
    return (
        <div className="flex flex-col content-center">
            <Collapser
                open={open}
                description={
                    <div className="flex gap-2.5 content-center">
                        {iconBefore}
                        <VText variant="H3" className="content-center">
                            {text}
                        </VText>
                    </div>
                }
                setOpen={setOpen}
            >
                <VText>Underpoint 1</VText>
                <VText>Underpoint 2</VText>
            </Collapser>
        </div>
    );
};

const SidebarHeader = () => {
    // get name from backend
    const username = 'User X';
    return (
        <div className="flex justify-between content-center pb-5 px-3 border-b-2 border-separator-opaque">
            <SidebarHeadline
                text={username}
                iconBefore={<PersonSimpleThrow size={22} color={semanticColors.label.primary} />}
            />
            <Bell size={22} color={semanticColors.label.primary} />
        </div>
    );
};

type SidebarItemProps = {
    linkDestination: string;
    text: string;
    iconBefore?: ReactNode;
};

const SidebarItem = ({ linkDestination, text, iconBefore }: SidebarItemProps) => {
    return (
        <Link to={linkDestination} className="flex gap-3">
            {iconBefore ?? iconBefore}
            <VText>{text}</VText>
        </Link>
    );
};

const Sidebar = () => {
    return (
        <div className="bg-background-secondary h-screen w-64 pt-4 border-r-2 border-separator-opaque">
            <SidebarHeader />

            <div className="space-y-2 px-3 py-3 ">
                <div className="pb-1">
                    <SidebarHeadline
                        text="Kystverket"
                        iconBefore={<Boat size={22} color={semanticColors.label.primary} />}
                    />
                </div>
                <SidebarItem
                    linkDestination="/home/all-projects"
                    text="All projects"
                    iconBefore={<CirclesFour size={22} color={semanticColors.label.primary} />}
                />
                <SidebarItem
                    linkDestination="/home/all-reports"
                    text="All reports"
                    iconBefore={<CirclesFour size={22} color={semanticColors.label.primary} />}
                />
                <SidebarItem
                    linkDestination="/home/admin"
                    text="Admin"
                    iconBefore={<SlidersHorizontal size={22} color={semanticColors.label.primary} />}
                />
            </div>
            <div className="pl-4">
                <VText variant="D1B" significance="tertiary">
                    Favorites
                </VText>
            </div>
        </div>
    );
};

export default Sidebar;
